export default {
  bind(el, binding) {
    // 默认颜色
    const rippleColor = binding.value || 'rgba(30, 136, 229, 0.15)';

    el.style.position = 'relative';
    el.style.overflow = 'hidden';

    el.addEventListener('click', function (e) {
      const rect = el.getBoundingClientRect();
      const ripple = document.createElement('span');

      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      ripple.style.position = 'absolute';
      ripple.style.borderRadius = '50%';
      ripple.style.pointerEvents = 'none';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      ripple.style.backgroundColor = rippleColor;
      ripple.style.transform = 'scale(0)';
      ripple.style.opacity = '0.75';
      ripple.style.transition = 'transform 0.4s ease-out, opacity 0.6s ease-out';
      ripple.className = 'v-ripple-effect';

      el.appendChild(ripple);

      // 触发动画
      requestAnimationFrame(() => {
        ripple.style.transform = 'scale(2)';
        ripple.style.opacity = '0';
      });

      // 动画结束后移除
      ripple.addEventListener('transitionend', () => {
        ripple.remove();
      });
    });
  }
};
